<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import ContactForm from "../components/ContactForm.svelte";
	import { weddingsCakeEnquiryPathMap, weddingsPathMap } from "../../../core/schema/paths/weddingsPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";
	import Link from "../components/Link.svelte";
	import { appName } from "../../../core/schema/names/appName.js";
	import cakes from "../../../core/assets/cakes.png?w=496&webp&imagetools";
	import weddingCake from "../../../core/assets/wedding-cake.png?w=496&webp&imagetools";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import { categoryPathMap } from "../../../core/schema/paths/categoryPathMap.js";
	import type { ContactProps } from "./ContactProps";

	type $$Props = ContactProps;
	const { plannedIceCreams } = $$restProps as $$Props;

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<Layout>
	<div class="container">
		<section>
			<h1 class="decorative-headline pb-4">{nbspify("Kontakt")}</h1>
			<div class="mt-2 flex flex-col justify-evenly gap-5 md:mt-4 md:flex-row md:gap-2">
				<div
					class="h-initial group flex flex-col rounded-[1.375rem] border border-gray-300 p-4 transition-all duration-300 min-[430px]:w-[initial] min-[430px]:basis-[calc(50%-0.5rem)] sm:basis-[calc(50%-0.25rem)] md:basis-[calc(50%-0.75rem)] lg:basis-[calc((100%-(2*.75rem))/2)] xl:basis-[calc((100%-(2*1.5rem))/2)] xl:p-6"
				>
					<h4 class="ml-0 text-lg font-semibold">Chcete si objednat dort?</h4>
					<StaticPicture
						alt="Logo {appName}"
						height={400}
						image={cakes}
						width={496}
						imgClass="rounded-md w-full h-[300px] lg:h-[400px] object-cover"
					/>
					<span class="mt-6"
						>{nbspify(
							"Proveďte objednávku online na našem e-shopu. Dorty si můžete upravit podle své preference a k objednávce přidat zákusky nebo minidezerty.",
						)}</span
					>
					<div class="mt-auto flex">
						<Link
							class="mt-6 !rounded-full border-2 border-gray-800 !px-5 !py-2 font-semibold hover:bg-gray-100"
							href="/{categoryPathMap.cakes[TENANT_LOCALE]}"
							variant="transparent"
							asButton
						>
							Začít nakupovat
						</Link>
					</div>
				</div>
				<div
					class="h-initial group flex w-full flex-col rounded-[1.375rem] border border-gray-300 p-4 transition-all duration-300 min-[430px]:w-[initial] min-[430px]:basis-[calc(50%-0.5rem)] sm:basis-[calc(50%-0.25rem)] md:basis-[calc(50%-0.75rem)] lg:basis-[calc((100%-(2*.75rem))/2)] xl:basis-[calc((100%-(2*1.5rem))/2)] xl:p-6"
				>
					<h4 class="ml-0 text-lg font-semibold">Chcete sladkou svatbu od nás?</h4>
					<StaticPicture
						alt="Logo {appName}"
						height={400}
						image={weddingCake}
						width={496}
						imgClass="rounded-md w-full h-[300px] lg:h-[400px] object-cover"
					/>
					<span class="mt-6"
						>{nbspify(
							"Děláme ty nejlepší svatební dorty. Můžete si projít naší stránku o svatebních dortech, udělat si představu a vyplnit poptávkový formulář.",
						)}</span
					>
					<div class="mt-auto flex">
						<Link
							class="mt-6 !rounded-full border-2 border-gray-800 !px-5 !py-2 font-semibold hover:bg-gray-100"
							href={`/${weddingsPathMap[TENANT_LOCALE]}#${weddingsCakeEnquiryPathMap[TENANT_LOCALE]}`}
							variant="transparent"
							asButton
						>
							Poptat termín svatby
						</Link>
					</div>
				</div>
			</div>

			<div class="mt-[7.5rem] text-center">
				<h2 class="!mb-8 text-xl lg:text-2xl">
					{nbspify("Napište nám dotaz či připomínku, ozveme se zpět, jak jen to bude možné.")}
				</h2>
				<p>
					{nbspify(
						"Pokud máte urgentní dotaz, který se týká objednávky, volejte prosím rovnou do jedné z našich cukráren, abychom na váš požadavek mohli reagovat hned.",
					)}
				</p>
			</div>

			<ContactForm />
		</section>

		<section>
			<Branches isSmallMargin {plannedIceCreams} />
			<div class="mt-20 text-center text-xl font-semibold leading-[1] lg:text-2xl">
				<span>Těšíme se</span>
				<span class="block">na vaši návštěvu!</span>
			</div>
		</section>
	</div>
</Layout>
